import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import HomeScreen from './HomeScreen';
import ManageScreen from "./ManageScreen";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HistoryScreen from "./HistoryScreen";
import AdminScreen from "./AdminScreen"
import AlertsHistory from "./AlertsHistory"
import PublicWarnings from "./PublicWarnings"

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path={"/subscriber/"}>
                    <Route path={":subscriber"}>
                        <Route path={"manage"} element={<ManageScreen />} />
                    </Route>
                </Route>
                <Route path={"/history"} element={<HistoryScreen />} />
                <Route path={"/admin"} element={<AdminScreen />} />
                <Route path={"/alertshistory"} element={<AlertsHistory />} />
                <Route path={"/warnings"} element={<PublicWarnings />} />
                <Route path={"*"} element={<HomeScreen />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
